export default function BasketFixedToCheckout(
    $q,
    $rootScope,
    Bookings,
    BookingPeriods,
    Basket,
    Users,
    paymentService,
    Log,
    ENV
) {
    var fn = this;

    fn.isFixed = true;

    fn.checkout = (user, activityId, periods, bookingId = null, isFixed) => {
        if (!periods.length) {
            return rejector("no-basket-periods");
        }

        fn.isFixed = isFixed;

        /**
         *  What now :-)
         *
         * if the user previously initiated created a booking, then lets check if we can continue to checkout using that.
         *
         *  Conditions:
         * - requires booking ID in basket (localstorage)
         * - all bps must have a status of "New"
         * - location and activity must be the same
         */

        /**
         *
         * TEST SCENARIOS
         */

        // TEST 1 - no booking ID
        // bookingId = null

        /** test activator */
        // basketBookings = forceFirstBookingToBeOutdated(basketBookings);

        // Test  - Periods is in past sense
        // Test  - Some basket periods was not available anymore

        // Test last - API errors -
        // resolvers
        // Test  - All booking periods are available...

        /**
         * If booking ID is Provided (forny)
         */
        if (bookingId) {
            Basket.setBookingId(bookingId);

            return useExistingBookingFlow(user, activityId, periods, bookingId);
        }

        return isBasketBookingIdUseable(periods).then(
            (res) => {
                // Existing booking found
                if (res.obj) {
                    // SET BookingId (from Basket)
                    const bookingId = res.obj.id;

                    return useExistingBookingFlow(
                        user,
                        activityId,
                        periods,
                        bookingId
                    );
                }
            },
            (err) => {
                // Create NEW
                return createNewBookingFlow(user, activityId, periods).then(
                    () => {
                        return resolver("READY FOR CHECKOUT");
                    },
                    (err) => {
                        return rejector(err.reason, err.obj);
                    }
                );
            }
        );
    };

    const useExistingBookingFlow = (user, activityId, periods, bookingId) => {
        return Bookings.get(bookingId).then(
            (res) => {
                const apiBooking = res;

                return existingBookingFlow(
                    user,
                    activityId,
                    periods,
                    apiBooking
                ).then(
                    (res) => {
                        // USE EXISTING
                        return resolver("CHECKOUT existing");
                    },
                    (err) => {
                        // HAS UNAVAILABLE PERIODS
                        return rejector(err.reason, err.obj);
                    }
                );
            },
            (err) => {
                return createNewBookingFlow(user, activityId, periods).then(
                    (res) => {
                        return resolver("READY FOR CHECKOUT");
                    },
                    (err) => {
                        // AWAIT USER TO REMOVE UNAVAILABLE PERIODS
                        return rejector(err.reason, err.obj);
                    }
                );
            }
        );
    };

    const isBasketBookingIdUseable = (periods) => {
        const basketBookingId = Basket.getBookingId();

        if (!basketBookingId) {
            return rejector("No BasketBookingId");
        }

        return Bookings.get(basketBookingId).then(
            (res) => {
                const basketBooking = res;

                const isFixedBps = basketBooking.bookingPeriods.filter(
                    (bp) => bp.bookingTypeId == 11 && bp.status == "New"
                );

                // activity /

                //  Booking Periods
                //  period.start == apiPeriod.start &&
                //  period.end == apiPeriod.end &&
                //  period.resourceId == apiPeriod.resourceId

                // does all returned bps match the bps we are trying to book ?
                // --
                // -- and what if only some of them exist etc.... ???

                // does returned API BOOKING have the same acitivity as Basket
                // does returned API BOOKING have the same location as Basket

                if (!!isFixedBps.length) {
                    console.log("Reuse BASKET booking ID ");

                    return resolver(
                        "Basket Booking passed tests",
                        basketBooking
                    );
                }

                return rejector("Basket booking did not pass tests", err);
            },
            (err) => {
                // CREATE NEW // OR USE ALLREADY PROVIDED BOOKING ID

                return rejector("get Booking API error ", err);
            }
        );
    };

    const deleteBookingPeriod = (apiBp) => {
        return Bookings.deleteBookingPeriod(apiBp);
    };

    const createBookingPeriod = (period, bookingId, activity, user) => {
        return Bookings.createBookingPeriod(period, bookingId, activity, user);
    };

    /**
     * ALLOW User to continue period with a "New" status
     * If apiPeriod status == "New" and the user owns the period..
     * 1: delete the apiPeriod
     * 2: set the matching period prop isAvailable = true
     * 3: readd the period to basket
     *
     * @param {*} unavailablePeriods
     * @param {*} apiBooking
     */
    // const isApiPeriodStatusNew = (
    //     apiBooking,
    //     unavailablePeriods,
    //     bookingId,
    //     activity,
    //     user
    // ) => {
    //     log.info("isApiPeriodStatusNew");
    //     console.log(apiBooking);
    //     console.log(unavailablePeriods);
    //     const updatedUnavailablePeriods = unavailablePeriods.filter(
    //         (period) => {
    //             const apiBpToReplace = apiBooking.bookingPeriods.find(
    //                 (apiPeriod) => {
    //                     if (apiPeriod.status !== "New") {
    //                         return false;
    //                     }

    //                     if (
    //                         period.start == apiPeriod.start &&
    //                         period.end == apiPeriod.end &&
    //                         period.resourceId == apiPeriod.resourceId
    //                     ) {
    //                         return true;
    //                     }

    //                     return false;
    //                 }
    //             );

    //             if (!apiBpToReplace) {
    //                 return resolver("its ok");
    //             }

    //             console.log(apiBpToReplace);
    //             return deleteBookingPeriod(apiBpToReplace).then(
    //                 (res) => {
    //                     console.log(res);

    //                     period.isAvailable = true;
    //                     return createBookingPeriod(
    //                         period,
    //                         bookingId,
    //                         activity,
    //                         user
    //                     );
    //                 },
    //                 (err) => {
    //                     return rejector(
    //                         "API - could not delete booking periods",
    //                         err
    //                     );
    //                 }
    //             );
    //         }
    //     );

    //     Bookings.get(bookingId).then((res) => {
    //         console.log(res);
    //     });

    //     console.log(updatedUnavailablePeriods);
    //     return resolver("removed bps from db", updatedUnavailablePeriods);
    // };

    const existingBookingFlow = (user, activity, periods, apiBooking) => {
        log.info("Existing booking flow");

        /*
         * FOR EACH PERIOD
         *
         * Continue existing ApiBooking ?
         * Conditions:
         *
         *    any unavailable periods
         *       ? does it exist in apiBooking (user owns this)
         *          ? use existing apiBooking period ( the user owns it )
         *          : addPeriod()
         *       :
         *    : continue existing apiBooking;
         */

        /**
         * CHECK TO SEE IF the new periods allready exist on the bookng...
         * periodAllreadyExistOnBooking
         *  ? period.status == "new"
         *      ? do not add period
         *      : addPeriod()
         *  : addPeriod()
         */

        /*
         updateBpsAvailability
            ? resolver =  useExistingBooking() = all available 
            : rejector = conditionalExistingBooking() = unavailable periods = does unavailable periods exist in apiBooking)
                    ? resolver = useExistingBooking() = all should be available now
                    : rejector : await user to remove periods
        */

        const promises = apiBooking.bookingPeriods
            .filter((bp) => bp.status == "New")
            .map((bp) => deleteBookingPeriod(bp));

        return $q.all(promises).then((res) => {
            log.info('All Bps with status "New" deleted');
            return updateBpsAvailability(periods, apiBooking.id).then(
                (res) => {
                    const updatedPeriods = res.obj;

                    log.info("updating (API) Basket periods with availability");

                    return useExistingBooking(
                        user,
                        activity,
                        updatedPeriods,
                        apiBooking
                    ).then(
                        () => {
                            return resolver(
                                "booking periods created ApiV3 format",
                                null
                            );
                        },
                        (err) => {
                            return rejector(
                                "API error - could not create booking periods",
                                err
                            );
                        }
                    );
                },
                (err) => {
                    console.log("conditionalExistingBooking");
                    return conditionalExistingBooking().then(
                        (res) => {
                            return useExistingBooking().then(
                                (res) => {
                                    /**
                                     * resolver
                                     */
                                    log.string("Added existing periods");
                                    return resolver(
                                        "Added periods to booking",
                                        err
                                    );
                                },
                                (err) => {
                                    log.string(
                                        "API could not add booking periods"
                                    );

                                    return rejector(
                                        "API could not add booking periods",
                                        err
                                    );
                                }
                            );
                        },
                        (err) => {
                            // console.warn(err);
                            return rejector(err.reason, err);
                        }
                    );
                }
            );
        });
    };

    const createNewBookingFlow = (user, activityId, periods) => {
        log.info("create New Booking Flow");

        return createNewBookingId(user).then(
            (res) => {
                const newBookingId = res.obj; // number
                log.info("New Booking Id created");

                return updateBpsAvailability(periods, newBookingId).then(
                    () => {
                        return createBookingPeriods(
                            user,
                            activityId,
                            periods,
                            newBookingId
                        ).then(
                            () => {
                                // console.log(res);
                                /**
                                 * SUCCESS - LAST ACTION IN createNewBookingFlow
                                 */
                                return resolver(
                                    "Booking with periods created",
                                    null
                                );
                            },
                            (err) => {
                                return rejector(
                                    "API - booking periods could not be created",
                                    err
                                );
                            }
                        );
                    },
                    (err) => {
                        return rejector(
                            "BookingPeriods CheckAvailability API failed",
                            err.obj
                        ); // passthrough
                    }
                );
            },
            (err) => {
                return rejector(err.reason, err.obj); // passthrough
            }
        );
    };

    const useExistingBooking = (user, activityId, periods, apiBooking) => {
        return createBookingPeriods(
            user,
            activityId,
            periods, // legacy
            apiBooking.id
        );
    };

    const createBookingPeriods = (user, activityId, periods, bookingId) => {
        const promises = periods.map((period) => {
            return Bookings.createBookingPeriod(
                period,
                bookingId,
                activityId,
                user,
                fn.isFixed
            );
        });

        return $q.all(promises);
    };

    const createNewBookingId = (user) => {
        return Bookings.createBookingId(user.id).then(
            (bookingId) => {
                Basket.setBookingId(bookingId);
                return resolver(
                    "New booking created ID : " + bookingId,
                    bookingId
                );
            },
            (err) => {
                return rejector("create bookingID API error");
            }
        );
    };

    const updateBpsAvailability = (periods, bookingId) => {
        const promises = checkPeriodAvailability(periods, bookingId);

        return $q.all(promises).then(
            (res) => {
                /**
                 * Since wee need to update the booking (each) period (each)..
                 * and resolve with promises the array gets nested
                 * Unpack the outer unneccesary array wrap
                 */
                const updatedBasketPeriods = res;
                return resolver(
                    "Periods availability updated",
                    updatedBasketPeriods
                );
            },
            (err) => {
                return rejector("API error when checking availability", err);
            }
        );
    };

    /**
     * Request the Api for availability
     *
     * @return {promise}
     */
    const checkPeriods = (periods) => {};

    /**
     * Get Available Repeatable as a Promise
     * @param  {obj} weekday [description]
     * @param  {obj} booking [description]
     * @return {promise} [description]
     */
    const checkPeriodAvailability = (periods, bookingId) => {
        // Assume we always have just 1 period in a booking

        const promises = periods.map((period) => {
            // https://momentjs.com/docs/#/displaying/as-iso-string/
            return BookingPeriods.checkAvailability(
                period.start,
                period.end,
                period.resourceId,
                bookingId,
                period // used to DummyApiPeriod
            ).then(
                (res) => {
                    // http://localhost:8080/search/periods/fodbold,%205-mands%20/hafnia-hallen?date=28-11-2020&start=6&end=23&hours=1

                    /** reponse ApiV3
                     * available: true || false // we only need to copy this as long as we are legacy
                     * end: "2020-11-28T12:00:00"
                     * resource: {id: 45, parentId: 20, name: "Hafnia-Kunstgræs 5-Mands - Bane 1", locationId: 34, parent: null, …}
                     * start: "2020-11-28T11:00:00"
                     * success: true
                     * message: "Check period succeeded"
                     */
                    const expiredBooking = Basket.CheckPeriodDateIsExpired(
                        period.end
                    );

                    /**
                     * !res.available ?
                     *
                     */

                    period.isAvailable = expiredBooking
                        ? false
                        : res.data.available; // true || false

                    return period; // do not use resolver() here
                },
                (err) => {
                    console.warn(err);
                    // period.Available = false;
                    return rejector("API error checkAvailability", err);
                }
            );
        });

        return promises;
    };

    /*
     ***** Utilities *****
     */
    const resolver = (reason, obj = null) => {
        log.string("resolver : " + reason, "basket-resolve");
        return $q.resolve({ reason: reason, obj: obj });
    };

    const rejector = (reason, obj = null) => {
        log.string("rejector : " + reason, "basket-rejection");
        return $q.reject({ reason: reason, obj: obj });
    };

    const log = {
        info: (string, theme = "basket-info") => {
            Log.string("basket to checkout : info:", string, theme);
        },
        string: (string, theme = "basket-info") => {
            Log.string("basket to checkout :", string, theme);
            ENV.enableLog ? console.log(string) : null;
        },
        obj: (obj, theme = "basket-info") => {
            Log.obj("basket to checkout", obj, theme);
        },
    };

    return fn;
}
